import * as React from "react";
import { renderPlaceholderBtn } from "./renderPlaceholderBtn";
import { renderPlaceholderInfo } from "./renderPlaceholderInfo";
export class EventCardPlaceholder extends React.PureComponent {
    constructor(props) {
        super(props);
        this.componentPrefix = "ev-card-placeholder";
    }
    renderItems(eventsCount) {
        let elements = [];
        for (let i = 1; i <= eventsCount; i++) {
            elements.push(React.createElement("div", { key: `${this.componentPrefix}__item__${i}`, className: `rj-ev-list__${this.componentPrefix}__items-wrap` },
                renderPlaceholderInfo(this.componentPrefix),
                renderPlaceholderBtn(this.componentPrefix)));
        }
        return elements;
    }
    render() {
        return (React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}` },
            React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}__header` },
                React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}__header-text` })),
            this.renderItems(this.props.eventsCount)));
    }
}
//# sourceMappingURL=EventCardPlaceholder.js.map